import { createSelector } from 'reselect'

const getAdminOnboardingData = state => state.adminOnboarding
const getMyAccountData = state => state.myAccount

const defaultData = {
	institutionName: '',
	institutionId: 0,
	stateId: 0,
	countryId: 0,
	city: '',
}

const schoolAdminOnboarding = createSelector(
	[getAdminOnboardingData, getMyAccountData],
	(adminOnboarding, myAccount) => {
		let schoolData = {}
		let canEditInstitution = true
		let trialDays = 0
		let userDataLoaded = false
		let countryIdUS = 0
		if (!(Object.keys(myAccount.data).length === 0 && myAccount.data.constructor === Object)) {
			schoolData.institutionName = myAccount.data.institutionName
			schoolData.institutionId = myAccount.data.institutionId
			schoolData.stateId = myAccount.data.stateId
			schoolData.countryId = myAccount.data.countryId
			schoolData.city = myAccount.data.city
			if (myAccount.data.institutionName !== '' &&
				(myAccount.data.stateId > 0 || myAccount.data.city !== '')
				&& myAccount.data.countryId > 0) {
				canEditInstitution = false
			}
			userDataLoaded = true
			countryIdUS = myAccount.data.countryIdUS
		} else {
			schoolData = defaultData
		}
		if (adminOnboarding.trialDays > 0) {
			trialDays = adminOnboarding.trialDays
		}
		return {
			countryIdUS,
			schoolData,
			days: trialDays,
			needsApproval: adminOnboarding.needsApproval,
			canEditInstitution,
			isValid: adminOnboarding.isValid,
			userDataLoaded,
			confirmSchoolSuccess: adminOnboarding.confirmSchoolSuccess,
			confirmSchoolError: adminOnboarding.confirmSchoolError,
		}
	}
)

export default schoolAdminOnboarding
